import { Component, OnInit, Input } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import { Company } from "src/app/models/company.model";
import { CompanyService } from "src/app/services/company.service";
import { ExternService } from "src/app/services/extern.service";
import { Extern } from "src/app/models/extern.model";

@Component({
    selector: 'app-search-extern',
    templateUrl: './search-extern.component.html',
    styleUrls: ['./search-extern.component.scss'],
    standalone: false
})
export class SearchExternComponent implements OnInit {

    public loading = false;
    public errorText = '';
    public chooseExtern: string | null = null;
    public externs: Extern[] = [];
    public externsToFilter: Array<number | string> = [];
    @Input() filterCoopsOnly: boolean = false;

    constructor(
        protected dialogRef: NbDialogRef<SearchExternComponent>,
        protected externService: ExternService,
        protected companyService: CompanyService
    ) { }

    ngOnInit(): void {

        const externsObservable = this.filterCoopsOnly
            ? this.externService.getCoops()
            : this.externService.getAll();
            
        externsObservable.subscribe(
            items => {
                if (items) {
                    this.externs = items.filter((element: Extern) => (this.externsToFilter.indexOf(element.id) == -1));
                }
            }
        );
    }

    saveAction(): void {

        this.loading = true;
        if (!this.chooseExtern) return;

        const idExtern = parseInt(this.chooseExtern);
        if (idExtern) {
            this.dialogRef.close({ type: 'extern', id: idExtern });
            return;
        }
        this.dialogRef.close({ type: this.chooseExtern });
    }

    closeAction(): void {
        this.dialogRef.close();
    }
}